<script setup lang="ts">
import { toRefs } from "vue";
import { RouterLink } from "vue-router";
import { utc2local } from "@/utils";
import type { Order } from "@/rvapi";

const props = defineProps<{
  orders: Order[];
  searching: boolean;
  title?: string;
}>();

const { orders, searching, title } = toRefs(props);
</script>

<template>
  <section v-show="!searching && orders.length > 0">
    <h3>{{ title ?? "Orders" }}</h3>
    <pn-table bordered="true" striped="true">
      <table>
        <thead>
          <tr>
            <th>Order</th>
            <th>User</th>
            <th>Email</th>
            <th>Status</th>
            <th>Date</th>
            <th></th>
            <th>Payment</th>
            <th>Total</th>
            <th>Cards</th>
            <th>Promotion</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders" :key="order.orderId">
            <td>
              <RouterLink :to="'/order/' + order.orderId">{{
                order.orderId
              }}</RouterLink>
            </td>
            <td>
              <RouterLink v-show="order.userId" :to="'/user/' + order.userId">{{
                order.userId
              }}</RouterLink>
            </td>
            <td>{{ order.customerEmail }}</td>
            <td>{{ order.orderStatus }}</td>
            <td>{{ utc2local(order.orderDate) }}</td>
            <td>{{ order.platform }}</td>
            <td>{{ order.paymentMethod }}</td>
            <td>{{ order.totalAmount / 100 }} {{ order.currencyCode }}</td>
            <td>{{ order.totalReceivers }}</td>
            <td>{{ order.promotionCode }}</td>
          </tr>
        </tbody>
      </table>
    </pn-table>
  </section>
</template>
<style lang="scss" scoped></style>
